import { api } from 'src/pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';
export default class AutoAccountingApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getAll(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    return super.post(api.auto_accounting_dashboard, formData);
  }

  public async getAccountPredictions(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    return super.post(api.auto_detect_accounts, formData);
  }

  public async deleteTrainingData(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    return super.delete(api.accounting_delete_training, formData);
  }

  public async trainModel(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    return super.post(api.accounting_train_model, formData);
  }
}
